import api from '../../axios';
import { handleApiError } from '../../errorHandler';

export interface IAdminShellPendingSummaries {
  marketIndicatorProposals: {
    actionablePendingCount: number;
  };
  myStationFlags: {
    pendingCount: number;
  };
}

const BASE_URL = '/admin/shell';

export const getAdminShellPendingSummaries = async (): Promise<IAdminShellPendingSummaries> => {
  try {
    const response = await api.get<IAdminShellPendingSummaries>(`${BASE_URL}/pending-summaries`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar pending summaries do admin:', error);
    throw handleApiError(error);
  }
};
